<template>
	<label class="ov-checkbox" :class="{ 'ov-checkbox--on': modelValue }">
		<input
			type="checkbox"
			class="ov-checkbox__input"
			:checked="modelValue"
			@change="$emit('update:modelValue', $event.target.checked)"
		/>
		<span class="ov-checkbox__box">
			<i v-if="modelValue" class="la la-check ov-checkbox__icon" />
		</span>
		<span v-if="$slots.default" class="ov-checkbox__label"><slot /></span>
	</label>
</template>

<script>
export default {
	name: "OvCheckbox",
	props: {
		modelValue: { type: Boolean, default: false },
	},
	emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
.ov-checkbox {
	display: inline-flex;
	align-items: center;
	gap: var(--ds-space-2);
	cursor: pointer;
	font-size: var(--ds-font-size-sm);
	user-select: none;

	&__input {
		position: absolute;
		opacity: 0;
		width: 0;
		height: 0;
		pointer-events: none;
	}

	&__box {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 18px;
		height: 18px;
		border: 1.5px solid var(--ds-color-border);
		border-radius: 5px;
		background: var(--ds-color-surface);
		flex-shrink: 0;
		transition: border-color var(--ds-duration-fast) var(--ds-ease-in-out),
			background var(--ds-duration-fast) var(--ds-ease-in-out),
			box-shadow var(--ds-duration-fast) var(--ds-ease-in-out);
	}

	&__icon {
		font-size: 11px;
		line-height: 1;
		color: var(--ds-color-primary-text);
	}

	&__label {
		color: var(--ds-color-text);
		line-height: var(--ds-line-height);
	}

	&:hover .ov-checkbox__box {
		border-color: var(--ds-color-primary-hover);
	}

	&--on .ov-checkbox__box {
		background: var(--ds-color-primary);
		border-color: var(--ds-color-primary);
		box-shadow: 0 1px 3px var(--ds-color-primary-subtle);
	}
}
</style>
